<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        lg="6"
      >
        <h6>CPU Usage</h6>
        <cpu-chart />
      </b-col>
      <b-col
        cols="12"
        lg="6"
      >
        <h6>Memory Usage</h6>
        <memory-chart
          :show-legend="false"
          :capacity="host.memoryCapacity"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col
        cols="12"
        lg="6"
      >
        <template v-if="gettingNetworkInterfaces">
          <div class="d-flex justify-content-center align-items-center">
            <b-spinner variant="primary" />
          </div>
        </template>
        <template v-else>
          <h6 v-if="networkInterfaces.length === 0">
            Network Requests
          </h6>
          <div
            v-else
            class="d-flex align-items-center  justify-content-between"
          >
            <h6 class="mb-0">
              Network Requests
            </h6>
            <v-select
              v-model="networkInterface"
              class="flex-fill distro-single-select"
              :options="networkInterfaces"
              placeholder="Select Network Interface"
            />
          </div>
          <network-chart :device-id="networkInterface || ''" />
        </template>
      </b-col>
      <b-col
        cols="12"
        lg="6"
      >
        <h6 class="system-header">
          File System
        </h6>
        <file-system-chart :show-legend="false" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CpuChart from './charts/CpuChart.vue'
import MemoryChart from './charts/MemoryChart.vue'
import NetworkChart from './charts/NetworkChart.vue'
import FileSystemChart from './charts/FileSystemChart.vue'
import vSelect from 'vue-select'

export default {
  name: 'MetricsOverview',
  components: {
    CpuChart,
    MemoryChart,
    NetworkChart,
    FileSystemChart,
    vSelect,
  },
  props: {
    host: {
      type: Object,
      required: true,
    },
  },
  computed: {
    networkInterface: {
      get() {
        return this.$store.state.observability.networkInterface
      },
      set(val) {
        this.$store.commit(
          'observability/SET_NETWORK_INTERFACE',
          val !== null ? val : this.networkInterface,
        )
      },
    },
    networkInterfaces() {
      return this.$store.state.observability.networkInterfaces
    },
    gettingNetworkInterfaces() {
      return this.$store.state.observability.gettingNetworkInterfaces
    },
  },
}
</script>
<style lang="scss" scoped>
.distro-single-select {
  max-width: 200px;
  height: 34px;

  ::v-deep {
    .vs__clear {
      display: none;
    }
  }
}
.system-header {
  height: 42px;
  margin-bottom: 0px;
}
</style>
